export const DEFAULT_SESSION_TIMEOUT_MINUTES = 15;
export const MIN_SESSION_TIMEOUT_MINUTES = 1;
export const MAX_SESSION_TIMEOUT_MINUTES = 60;
export const SESSION_EXPIRY_WARNING_MS = 60 * 1000;
export const SESSION_TIMING_UPDATED_EVENT = 'rxcap-session-timing-updated';

const SESSION_TIMEOUT_MINUTES_KEY = 'logout_timeout_minutes';
const SESSION_EXPIRES_AT_KEY = 'session_expires_at';

const dispatchSessionTimingUpdated = detail => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(SESSION_TIMING_UPDATED_EVENT, {
      detail,
    }),
  );
};

export const normalizeSessionTimeoutMinutes = value => {
  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) {
    return DEFAULT_SESSION_TIMEOUT_MINUTES;
  }

  const normalizedValue = Math.trunc(parsedValue);
  if (normalizedValue < MIN_SESSION_TIMEOUT_MINUTES || normalizedValue > MAX_SESSION_TIMEOUT_MINUTES) {
    return DEFAULT_SESSION_TIMEOUT_MINUTES;
  }

  return normalizedValue;
};

export const getSessionTimeoutMinutesFromOrgConfig = orgConfig =>
  normalizeSessionTimeoutMinutes(
    orgConfig?.general?.portal_logout_timeout ?? orgConfig?.general?.logout_timeout,
  );

export const setStoredSessionTimeoutMinutes = timeoutMinutes => {
  const normalizedTimeout = normalizeSessionTimeoutMinutes(timeoutMinutes);
  sessionStorage.setItem(SESSION_TIMEOUT_MINUTES_KEY, String(normalizedTimeout));
  return normalizedTimeout;
};

export const getStoredSessionTimeoutMinutes = () =>
  normalizeSessionTimeoutMinutes(sessionStorage.getItem(SESSION_TIMEOUT_MINUTES_KEY));

export const getSessionExpiryTimestamp = () => {
  const expiryTimestamp = Number(sessionStorage.getItem(SESSION_EXPIRES_AT_KEY));
  if (!Number.isFinite(expiryTimestamp) || expiryTimestamp <= 0) {
    return null;
  }

  return expiryTimestamp;
};

export const setSessionExpiryTimestamp = expiresAt => {
  if (!Number.isFinite(expiresAt) || expiresAt <= 0) {
    return null;
  }

  sessionStorage.setItem(SESSION_EXPIRES_AT_KEY, String(expiresAt));
  dispatchSessionTimingUpdated({
    expiresAt,
    timeoutMinutes: getStoredSessionTimeoutMinutes(),
  });
  return expiresAt;
};


export const touchSessionExpiry = (timeoutMinutes = getStoredSessionTimeoutMinutes()) => {
  const normalizedTimeout = setStoredSessionTimeoutMinutes(timeoutMinutes);
  const expiresAt = Date.now() + normalizedTimeout * 60 * 1000;

  sessionStorage.setItem(SESSION_EXPIRES_AT_KEY, String(expiresAt));
  dispatchSessionTimingUpdated({
    expiresAt,
    timeoutMinutes: normalizedTimeout,
  });

  return expiresAt;
};

export const syncSessionExpiryFromRemainingSeconds = remainingSeconds => {
  const normalizedRemainingSeconds = Number(remainingSeconds);
  if (!Number.isFinite(normalizedRemainingSeconds) || normalizedRemainingSeconds <= 0) {
    return null;
  }

  return setSessionExpiryTimestamp(Date.now() + normalizedRemainingSeconds * 1000);
};

export const syncSessionTiming = orgConfig => {
  const timeoutMinutes = orgConfig ? getSessionTimeoutMinutesFromOrgConfig(orgConfig) : getStoredSessionTimeoutMinutes();
  return touchSessionExpiry(timeoutMinutes);
};
